import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { peopleGateway } from './index';

const REFRESH_MS = 60_000;

/**
 * EPN-216: how many employee questions are waiting for a reply, for the side menu. Re-read when the route changes (so answering one updates the
 * count as soon as the admin moves on) and once a minute. A refused or failed read (for example a role without employee access) shows no count.
 */
export function useOpenEmployeeQuestionCount(): number {
  const [count, setCount] = useState(0);
  const { pathname } = useLocation();

  useEffect(() => {
    let cancelled = false;
    const read = () => {
      peopleGateway.listEmployeeQuestions('open')
        .then((items) => { if (!cancelled) setCount(items.length); })
        .catch(() => { if (!cancelled) setCount(0); });
    };
    read();
    const timer = setInterval(read, REFRESH_MS);
    return () => { cancelled = true; clearInterval(timer); };
  }, [pathname]);

  return count;
}
